import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Enables swipe-from-left-edge to navigate back.
 * Only triggers when the swipe starts within 30px of the left edge,
 * moves at least 80px to the right, and is more horizontal than vertical.
 */
export default function useSwipeBack() {
  const navigate = useNavigate();
  const location = useLocation();
  const startRef = useRef<{ x: number; y: number } | null>(null);

  useEffect(() => {
    const onTouchStart = (e: TouchEvent) => {
      const touch = e.touches[0];
      if (touch.clientX <= 30) {
        startRef.current = { x: touch.clientX, y: touch.clientY };
      } else {
        startRef.current = null;
      }
    };

    const onTouchEnd = (e: TouchEvent) => {
      if (!startRef.current) return;
      const touch = e.changedTouches[0];
      const dx = touch.clientX - startRef.current.x;
      const dy = Math.abs(touch.clientY - startRef.current.y);
      startRef.current = null;

      // Must swipe at least 80px right, and more horizontal than vertical
      if (dx > 80 && dx > dy * 1.5 && location.pathname !== '/') {
        navigate(-1);
      }
    };

    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchend', onTouchEnd, { passive: true });

    return () => {
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchend', onTouchEnd);
    };
  }, [navigate, location.pathname]);
}
